import { useTranslation } from 'react-i18next';
import { LANGUAGES, setLanguage, type Language } from '../../i18n';
import { useTheme } from '../../theme/ThemeContext';
import { Button } from '../../components/Button';
import { ChangePasswordForm } from '../auth/ChangePasswordForm';
import styles from './SettingsPage.module.css';

/** Einstellungen des angemeldeten Benutzers: Passwort ändern, Sprache und Darstellung. */
export function SettingsPage() {
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  return (
    <section>
      <h1>{t('settings.title')}</h1>
      <div className={styles.grid}>
        <div className={styles.card}>
          <h2>{t('password.title')}</h2>
          <ChangePasswordForm />
        </div>
        <div className={styles.card}>
          <h2>{t('settings.appearance')}</h2>
          <p>
            <label>
              {t('settings.language')}{' '}
              <select
                value={i18n.language}
                onChange={(event) => void setLanguage(event.target.value as Language)}
              >
                {LANGUAGES.map((language) => (
                  <option key={language} value={language}>
                    {t(`lang.${language}`)}
                  </option>
                ))}
              </select>
            </label>
          </p>
          <Button variant="secondary" onClick={toggleTheme}>
            {theme === 'dark' ? t('theme.toLight') : t('theme.toDark')}
          </Button>
        </div>
      </div>
    </section>
  );
}
